<template>
    <b-modal id="wheelInfoModal" size="lg" :hide-footer="true">
        <h3 class="text-white text-center">Колесо фортуны</h3>
        <div class="row mx-0 my-3"  v-if="wheelStats">
            <span class="text-white text-center">
                Колесо Фортуны активируется при пополнении от {{wheelStats.profitBorder}} руб. в течение 30 дней.
            </span>
            <span class="text-white text-center mt-4">
                К примеру: для доступа к Колесу Фортуны сегодня, сумма Ваших пополнений за {{setDates.monthAgo}} до
                {{setDates.now}} должна быть больше {{wheelStats.profitBorder}} руб.
            </span>
        </div>
        <div class="row mx-0 my-4">
            <router-link :to="{ name: 'deposit' }" class="btn account-btn mx-auto px-5 pt-2">
                Депозит
            </router-link>
        </div>
    </b-modal>
</template>

<script>
    export default {
        computed: {
            setDates() {
                let date = new Date()
                let monthAgo = new Date(date)
                monthAgo.setDate(monthAgo.getDate() - 30)
                date = new Date(date).toLocaleString('ru-RU', {hour12: false})
                monthAgo = new Date(monthAgo).toLocaleString('ru-RU', {hour12: false})

                return {now: date, monthAgo: monthAgo}
            },
          wheelStats() {
            return this.$store.getters.getWheelStats
          },
        }
    }
</script>
